import { brandAdminService } from '@/services';

export const brandAdminModule = {
  namespaced: true,
  state: () => ({
    list: {
      data: null,
      response: null,
      status: 'idle',
    },
    listFilters: {},
    brand: {
      data: null,
      response: null,
      status: 'idle',
    },
    newBrand: {
      data: null,
      response: null,
      status: 'idle',
    },
    updateBrand: {
      response: null,
      status: 'idle',
    },
    deleteBrand: {
      response: null,
      status: 'idle',
    }
  }),
  mutations: {
    setListError(state, response) {
      state.list.data = null;
      state.list.response = response;
      state.list.status = 'error';
    },
    setListLoading(state) {
      state.list.data = null;
      state.list.response = null;
      state.list.status = 'loading';
    },
    setListSuccess(state, response) {
      state.list.data = response?.data || null;
      state.list.response = response;
      state.list.status = 'success';
    },
    setListFilters(state, request) {
      state.listFilters = { ...JSON.parse(JSON.stringify(request)) }
    },
    setBrandError(state, response) {
      state.list.data = null;
      state.list.response = response;
      state.list.status = 'error';
    },
    setBrandLoading(state) {
      state.list.data = null;
      state.list.response = null;
      state.list.status = 'loading';
    },
    setBrandSuccess(state, response) {
      state.list.data = response?.data || null;
      state.list.response = response;
      state.list.status = 'success';
    },
    setNewBrandError(state, response) {
      state.newBrand.data = null;
      state.newBrand.response = response;
      state.newBrand.status = 'error';
    },
    setNewBrandSuccess(state, response) {
      state.newBrand.data = response?.data || null;
      state.newBrand.response = response;
      state.newBrand.status = 'success';
    },
    setNewBrandWaiting(state) {
      state.newBrand.data = null;
      state.newBrand.response = null;
      state.newBrand.status = 'waiting';
    },
    setUpdateBrandError(state, response) {
      state.list.response = response;
      state.list.status = 'error';
    },
    setUpdateBrandSuccess(state, response) {
      state.list.response = response;
      state.list.status = 'success';
    },
    setUpdateBrandWaiting(state) {
      state.list.response = null;
      state.list.status = 'waiting';
    },
    setDeleteBrandError(state, response) {
      state.deleteBrand.response = response;
      state.deleteBrand.status = 'error';
    },
    setDeleteBrandSuccess(state, response) {
      state.deleteBrand.response = response;
      state.deleteBrand.status = 'success';
    },
    setDeleteBrandWaiting(state) {
      state.deleteBrand.response = null;
      state.deleteBrand.status = 'waiting';
    },
  },
  actions: {
    async getBrands({ commit }, request) {
      commit('setListLoading');
      commit('setListFilters', request);
      try {
        const response = await brandAdminService.getBrands(request.filters, request.pagination);
        console.log(response);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    },
    
    async insertBrand({ commit }, payload) {
      commit('setNewBrandWaiting');
      try {
        const response = await brandAdminService.insertBrand(payload);
        commit('setNewBrandSuccess', response);
      } catch (error) {
        commit('setNewBrandError', error);
        throw error;
      }
    },
    /* async getBrand({ commit }, request) {
      commit('setBrandLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await brandsAdminService.getBrand(request.pagination, user.customer._id);
        commit('setListSuccess', response);
      } catch (error) {
        commit('setListError', error);
        throw error;
      }
    }, */






    /* async exportStockProducts({ commit }, request) {
      commit('setExportLoading');
      try {
        const user = JSON.parse(localStorage.getItem("user"));
        const response = await usersAdminService.exportStockProducts(request.filters, request.language, user.customer._id);
        commit('setExportSuccess', response);
      } catch (error) {
        commit('setExportError', error);
        throw error;
      }
    } */
  }







  
  /* mutations: {
    load(state, request) {
      let pagination=null;
      let filters=null;
      if (request){
        pagination= request.pagination;
        filters= request.filters;}
      customerService.getCustomers(pagination,filters)
      .then((res) => {
        state.list.data = res
      })
      .catch((error) => {
        state.list.data = null
        state.list.error = error
      });    
    },
    getById(state, id) {
      customerService.getClientById(id)
        .then((res) => {
          state.client.data = res
        })
        .catch((error) => {
          state.client.data = null
          state.client.error = error
        });      
    },
    createClient(state, body) {
      customerService.newClient(body)
      .then((res) => {
        state.newClient.data = res
        state.newClient.status= {
          created: true
        }
      })
      .catch((error) => {
        state.newClient.data = null
        state.newClient.status ={
          error: error,
        }
      });    
    },
    updateClient(state, request) {
      customerService.updateClient(request.body, request.id)
      .then((res) => {
        state.updateClient.data = res
        state.updateClient.status = {updated: true}
      })
      .catch((error) => {
        state.updateClient.data = null
        state.updateClient.status = { error: error}
      });    
    },
    
  } */
}